import React from "react";
import "./AjeetMiniVideo.css";
import sampleVideo from "../../assets/AjeetminiVideo.mp4";

const AjeetMiniVideo = () => {
  return (
    <div className="zuppa_ajeetmini_video_pg_wrapper">
      <video
        className="zuppa_ajeetmini_video_pg_video"
        src={sampleVideo}
        autoPlay
        muted
        loop
        playsInline
      />
    
    </div>
  );
};

export default AjeetMiniVideo;
